import Module from "./Module";
import WABlastList from "./../wa-blast/views/WABlastList";
import ModalJedaBlast from "./../wa-blast/components/modal/ModalJedaBlast";
import ModalHentikanBlast from "./../wa-blast/components/modal/ModalHentikanBlast";
import ModalPilihPerangkat from "./../wa-blast/components/modal/ModalPilihPerangkat";
import WABlastCreate from "./../wa-blast/views/WABlastCreate";
import ModalKonfirmasiBlast from "./../wa-blast/components/modal/ModalKonfirmasiBlast";
import WABlastTemplateList from "./../wa-blast/views/WABlastTemplateList";
import WABlastPilihKonsumen from "./../wa-blast/views/WABlastPilihKonsumen";
import WABlastTemplatePesanList from "./../wa-blast/views/WABlastTemplatePesanList";
import ModalHapusTemplatePesan from "./../wa-blast/components/modal/ModalHapusTemplatePesan";
import WABlastDetail from "./../wa-blast/views/WABlastDetail";
import ModalFilterWABlastKonsumen from "./../wa-blast/components/modal/ModalFilterWABlastKonsumen";
import ModalPreviewTemplatePesan from "./../wa-blast/components/modal/ModalPreviewTemplatePesan";
import WABlastTemplateCreate from "./../wa-blast/views/WABlastTemplateCreate";
import WABlastTemplateEdit from "./../wa-blast/views/WABlastTemplateEdit";
import PanduanPenuliasanWaBlast from "./../wa-blast/components/modal/PanduanPenuliasanWaBlast";

const requireAuth = {requireAuth: true};

const moduleRoute = {
	path: "/wa-blast",
	component: Module,
	children: [
		{
			path: "",
			name: "wa_blast",
			component: Module,
			children: [
				{
					path: '',
					name: "wa_blast.list",
					component: WABlastList,
					meta: {
                        ...requireAuth,
                        accessKey: 'whatsappAutosender.whatsappBlast',
                    },
				},
				{
					path: 'detail',
					name: "wa_blast.detail",
					component: Module,
					children: [
						{
							path: ':id',
							name: "wa_blast.detail.index",
							component: WABlastDetail,
							meta: {
								...requireAuth,
								accessKey: 'whatsappBlast.read'
							}
						},
						{
							path: 'jeda/:id',
							name: 'wa_blast.detail.jeda',
							components: {
								default: WABlastDetail,
								dialog: ModalJedaBlast
							},
							meta: {
								...requireAuth,
								accessKey: 'whatsappBlast.update'
							}
						},
						{
							path: 'hentikan/:id',
							name: 'wa_blast.detail.hentikan',
							components: {
								default: WABlastDetail,
								dialog: ModalHentikanBlast
							},
							meta: {
								...requireAuth,
								accessKey: 'whatsappBlast.update'
							}
						},
						{
							path: 'preview/:id/:mode',
							name: 'wa_blast.detail.template',
							components: {
								default: WABlastDetail,
								dialog: ModalPreviewTemplatePesan
							},
							meta: {
								...requireAuth,
								accessKey: 'whatsappBlast.template'
							}
						},
						{
							path: 'preview-message/:msg',
							name: 'wa_blast.detail.preview_message',
							components: {
								default: WABlastDetail,
								dialog: () => {
                  return import('./components/modal/ModalPreviewMessage.vue')
                }
							},
						},
					],
				},
				{
					path: 'jeda/:id',
					name: 'wa_blast.jeda',
					components: {
						default: WABlastList,
						dialog: ModalJedaBlast
					},
					meta: {
						...requireAuth,
						accessKey: 'whatsappBlast.update'
					}
				},
				{
					path: 'hentikan/:id',
					name: 'wa_blast.hentikan',
					components: {
						default: WABlastList,
						dialog: ModalHentikanBlast
					},
					meta: {
						...requireAuth,
						accessKey: 'whatsappBlast.update'
					}
				},
				{
					path: 'pilih-perangkat',
					name: 'wa_blast.pilih-perangkat',
					components: {
						default: WABlastList,
						dialog: ModalPilihPerangkat
					},
					meta: {
						...requireAuth,
						accessKey: 'whatsappBlast.update'
					}
				},
			]
		},
		{
			path: 'create',
			name: "wa_blast.create",
			component: Module,
			meta: {
				...requireAuth,
				accessKey: 'whatsappBlast.create'
			},
			children: [
				{
					path: '',
					name: "wa_blast.create.form",
					component: WABlastCreate,
					meta: requireAuth
				},
				{
					path: '',
					name: 'wa_blast.create.confirm',
					components: {
						default: WABlastCreate,
						dialog: ModalKonfirmasiBlast
					},
					meta: requireAuth,
				},
			]
		},
		{
			path: 'template',
			component: Module,
			meta: {
				...requireAuth,
				accessKey: 'whatsappBlast.template'
			},
			children: [
				{
					path: '',
					name: "wa_blast.template.list",
					component: WABlastTemplateList,
					meta: {
						...requireAuth,
						accessKey: 'template.read'
					}
				},
				{
					path: 'preview/:id/:title/:mode',
					name: 'wa_blast.template.preview',
					components: {
						default: WABlastTemplateList,
						dialog: ModalPreviewTemplatePesan
					},
					meta: {
						...requireAuth,
						accessKey: 'template.read'
					}
				},
			],
		},
		{
			// path: 'pilih-konsumen',
			// name: "wa_blast.pilih_konsumen",
			// component: Module,
			// meta: requireAuth,
			// children: [
			// 	{
			// 		path: '',
			// 		name: "wa_blast.pilih_konsumen.list",
			// 		component: WABlastPilihKonsumen,
			// 		meta: requireAuth
			// 	},
			// ]
			path: 'pilih-konsumen',
			name: "wa_blast.pilih_konsumen",
			component: Module,
			children: [
				{
					path: '',
					name: "wa_blast.pilih_konsumen.list",
					component: WABlastPilihKonsumen,
					meta: {
						...requireAuth,
						accessKey: 'whatsappBlast.update'
					}
				},
				{
					path: 'filter',
					name: 'wa_blast.pilih_konsumen.filter',
					components: {
						default: WABlastPilihKonsumen,
						dialog: ModalFilterWABlastKonsumen
					},
				},
			]
		},
		{
			path: 'template-pesan',
			name: "wa_blast.template-pesan",
			component: Module,
			meta: requireAuth,
			children: [
				{
					path: '',
					name: "wa_blast.template-pesan.list",
					component: WABlastTemplatePesanList,
					meta: {
						...requireAuth,
						accessKey: 'template.read',
					}
				},
				// {
				// 	path: 'create',
				// 	name: "wa_blast.template-pesan.create",
				// 	component: WABlastTemplateCreate,
				// 	meta: requireAuth
				// },
				{
					path: 'create',
					component: Module,
					children: [
						{
							path: '',
							name: "wa_blast.template-pesan.create",
							component: WABlastTemplateCreate,
							meta: {
								...requireAuth,
								accessKey: 'template.create',
							}
						},
						{
							path: 'panduan',
							name: 'wa_blast.template-pesan.create.panduan',
							components: {
								default: WABlastTemplateCreate,
								dialog: PanduanPenuliasanWaBlast
							},
						},
					],
				},
				// {
				// 	path: 'edit/:id',
				// 	name: "wa_blast.template-pesan.edit",
				// 	component: WABlastTemplateEdit,
				// 	meta: requireAuth
				// },
				{
					path: 'edit/:id',
					component: Module,
					meta: {
						...requireAuth,
						accessKey: 'template.update',
					},
					children: [
						{
							path: '',
							name: "wa_blast.template-pesan.edit",
							component: WABlastTemplateEdit,
							meta: requireAuth
						},
						{
							path: 'panduan',
							name: 'wa_blast.template-pesan.edit.panduan',
							components: {
								default: WABlastTemplateEdit,
								dialog: PanduanPenuliasanWaBlast
							},
						},
						{
							path: 'hapus/:id',
							name: 'wa_blast.template-pesan.edit.confirm-delete',
							components: {
								default: WABlastTemplateEdit,
								dialog: ModalHapusTemplatePesan
							},
							meta: {
								...requireAuth,
								accessKey: 'template.delete',
							}
						},
					],
				},
				{
					path: 'confirm-delete/:id',
					name: 'wa_blast.template-pesan.confirm-delete',
					components: {
						default: WABlastTemplatePesanList,
						dialog: ModalHapusTemplatePesan
					},
					meta: requireAuth
				},
				{
					path: 'preview/:id/:mode',
					name: 'wa_blast.template-pesan.template',
					components: {
						default: WABlastTemplatePesanList,
						dialog: ModalPreviewTemplatePesan
					},
				},
			]
		},
	]
}

export default (router) => {
	router.addRoutes([moduleRoute]);
};
